import React from 'react'

const CustomerPrivacyPolicy = () => {
    return (
        <div>CustomerPrivacyPolicy</div>
    )
}

export default CustomerPrivacyPolicy